import { trackAnalyticsEvent } from '@cof/refi-web-sdk/dist/utils/track-analytics-event.js';
import { REFI_MFE_UUID } from '@cof/refi-web-sdk';

function isStaticCloud() {
  return window.location.host === 'auto-refi-dev.clouddqt.capitalone.com' || window.location.host === 'auto-refi-sb.clouddqt.capitalone.com' || window.location.host === 'auto-refi-perf.clouddqt.capitalone.com';
}

const ENV_PATH = isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_LOGIN_CONST = {
  ENV_PATH,
  BASE_ACCESS_URL: 'api/Access/',
  BASE_AUTH_URL: `${ENV_PATH}/protected/831647/host-app/bff/auth`,
  HOST_APP_BFF_DXGW_URL: `${ENV_PATH}/protected/831647/host-app/bff/`,
  BASE_FETCH_USER_URL: `${ENV_PATH}/protected/831647/host-app/bff/fetch-user-info`,
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    'Content-Type': 'application/json;v=1',
    'Api-Key': 'RTM',
    'Client-Correlation-Id': REFI_MFE_UUID.makeUUID(),
  },
  REFI_SESSION_KEY: 'auto-refi-session',
  isSBEnv() {
    return window.location.hostname === 'auto-refi-sb.clouddqt.capitalone.com';
  },
  isDevEnv() {
    return window.location.hostname === 'auto-refi-dev.clouddqt.capitalone.com';
  },
  isPerfEnv() {
    return window.location.hostname === 'auto-refi-perf.clouddqt.capitalone.com';
  },
  isQAEnv() {
    return window.location.hostname === 'autorefi-ext-preprod.capitalone.com' || window.location.hostname === 'coaf-refi-web-ui-qa.capitalone.com';
  },
  isNonProdEnv() {
    return window.location.hostname !== 'autorefi.capitalone.com' && window.location.hostname !== 'coaf-refi-web-ui.capitalone.com';
  },
  TRACK_EVENT: trackAnalyticsEvent,
  USER_INFO_ERROR: '5008',
};

export const QUERY_PARAMS = {
  EXTERNAL_ID: 'external_id',
  LEADS: 'rl',
  BANDIT_EXPERIMENT_ID: 'banditExperimentId',
  BANDIT_FEEDBACK_ID: 'banditFeedbackId',
  PFFSRCID: 'PFFSRCID',
  EXPERIMENT: 'exp',
  REFI_ALLOCATION: 'refi_allocation',
  REFI_ANALYTICS: 'refi_analytics',
};
